import { LifeEventEnum } from './life-event-enum.generated';

const x: { [index: string]: string } = {};
x[LifeEventEnum.None] = 'None';
x[LifeEventEnum.Marriage] = 'Marriage';
x[LifeEventEnum.Divorce] = 'Divorce';
x[LifeEventEnum.DeathOfSpouse] = 'Death Of Spouse';
x[LifeEventEnum.BirthOfChild] = 'Birth Of Child';
x[LifeEventEnum.DeathOfChild] = 'Death Of Child';
x[LifeEventEnum.ChangeInEligibility] = 'Change In Eligibility';
x[LifeEventEnum.Other] = 'Other';
x[LifeEventEnum.PartTimeToFullTime] = 'Part Time To Full Time';
x[LifeEventEnum.Adoption] = 'Adoption';
x[LifeEventEnum.LossOfCoverage] = 'Loss Of Coverage';
x[LifeEventEnum.GainOfCoverage] = 'Gain Of Coverage';
x[LifeEventEnum.NetworkChange] = 'Network Change';
export const LifeEventEnumDescriptions: { [indexer: string]: string } = x;
